import React from "react";
import Dialog from "@mui/material/Dialog";
import { Form, Formik, FormikHelpers } from "formik";
import { object, string } from "yup";
import { BranchFormValues } from "src/models/Branch.model";
import BranchForm from "../Layouts/BranchForm";
import { useAddBranchMutation } from "src/services/BranchServices";
import { showToast } from "src/utils/showToaster";

type Props = {
  onClose: () => void;
};

const AddBranchFormWrapper = ({ onClose }: Props) => {
  const [addBranch] = useAddBranchMutation();

  // Form Initial Values
  const initialValues: BranchFormValues = {
    branchName: "",
    branchCode: "",
    branchAddress: "",
    country: "",
    state: "",
    city: "",
    lat: "",
    long: "",
  };

  // Validation Schema
  const validationSchema = object().shape({
    branchName: string().required("Branch name is required"),
    branchCode: string().required("Branch code is required"),
    branchAddress: string().required("Branch address is required"),
    country: object().required("Country is required"),
    state: object().required("State is required"),
    city: object().required("City is required"),
    lat: string().required("Latitude  is required"),
    long: string().required("Longitude  is required"),
  });

  // Handle Submit
  const handleSubmit = (
    values: BranchFormValues,
    { setSubmitting, resetForm }: FormikHelpers<BranchFormValues>
  ) => {
    const formattedValues = {
      branchName: values?.branchName,
      branchCode: values?.branchCode,
      branchAddress: values?.branchAddress,
      countryId: values?.country?._id,
      stateId: values?.state?._id,
      cityId: values?.city?._id,
      lat: values?.lat,
      long: values?.long,
    };

    addBranch(formattedValues).then((res: any) => {
      if (res?.error) {
        showToast("error", res?.error?.data?.message);
      } else {
        if (res?.data?.status) {
          showToast("success", res?.data?.message);
          resetForm();
          onClose();
        } else {
          showToast("error", res?.data?.message);
        }
      }
      setSubmitting(false);
    });
  };

  return (
    <Dialog open maxWidth="xs" fullWidth>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {(formikProps) => (
          <Form>
            <BranchForm
              formType="ADD"
              formikProps={formikProps}
              onClose={onClose}
            />
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};

export default AddBranchFormWrapper;
